import {useQuery} from "react-query"
import useAuth from "auth/useAuth"

export default function useLevels(userId, history=false) {
    
    const {auth, API, username} = useAuth()
    const query = useQuery(
        ["levels", userId],
        () => auth(API.rescuersIdLevelsGet, {id: userId, history}).then(response => response.data)
    )
    
    return {...query, levels: query.data}
}
